require('./vendor/bootstrap.min');
require('./vendor/slick');

require('./main');
require('./menu');
require('./sliders');
require('./animations');